import styled from "styled-components"

export default styled.div`
  iframe {
    min-height: 250px;
    max-height: 600px;
  }
`
